import { render, staticRenderFns } from "./AddStudentPay.vue?vue&type=template&id=29854efc&scoped=true&"
import script from "./AddStudentPay.vue?vue&type=script&lang=js&"
export * from "./AddStudentPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29854efc",
  null
  
)

export default component.exports